export default __webpack_public_path__ + "static/media/ugo-elbow-gradebreak.e03f1241.svg";